import { motion } from "framer-motion";
import { Zap, Compass, ShieldCheck, Users } from "lucide-react";

const values = [
  {
    icon: Zap,
    title: "Performance",
    desc: "Resultados que impulsionam.",
  },
  {
    icon: Compass,
    title: "Inovação",
    desc: "Sempre um passo à frente.",
  },
  {
    icon: ShieldCheck,
    title: "Compromisso",
    desc: "Seu crescimento é o nosso foco.",
  },
  {
    icon: Users,
    title: "Parceria",
    desc: "Crescemos juntos.",
  },
];

const Values = () => (
  <section className="relative border-y border-paper/5 bg-surface/30 py-20 sm:py-24">
    <div className="mx-auto max-w-6xl px-5">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-14 max-w-2xl"
      >
        <p className="mb-3 flex items-center gap-3 font-display text-[11px] font-bold uppercase tracking-[0.35em] text-brand-neon">
          <span className="h-px w-8 bg-brand-neon/60" />
          Conceito da marca
        </p>
        <h2 className="font-display text-2xl font-extrabold leading-snug tracking-tight sm:text-4xl">
          Tecnologia e estratégia
          <br />
          para empresas <span className="text-brand-neon">crescerem.</span>
        </h2>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-mist sm:text-base">
          A ED LABS é uma agência de soluções digitais que une criatividade,
          tecnologia e performance para transformar ideias em resultados reais.
        </p>
      </motion.div>

      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {values.map((v, i) => (
          <motion.div
            key={v.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="group"
          >
            <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-full border border-brand-neon/40 bg-brand/10 text-brand-neon transition-all duration-300 group-hover:bg-brand-neon group-hover:text-ink group-hover:shadow-[0_0_25px_rgba(168,85,247,0.5)]">
              <v.icon className="h-5 w-5" strokeWidth={2.2} />
            </span>
            <h3 className="font-display text-base font-bold">{v.title}</h3>
            <p className="mt-1 text-sm text-mist">{v.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Values;
